import ManualReviewForm from "./manual-review-form";
import FormSourceReviewForm from "./form-source-review-form";
import type { ReviewResponse } from "../types";

interface ReviewFormProps {
	onSuccess: (review: ReviewResponse) => void;
	onCancel: () => void;
	editMode?: boolean;
	initialData?: ReviewResponse | null;
}

export default function ReviewForm({ onSuccess, onCancel, editMode = false, initialData = null }: ReviewFormProps) {
	// Determine which form to show based on the source
	const isFormSource = initialData?.source === "form";

	// For create mode (not edit mode), always use ManualReviewForm
	if (!editMode) {
		return <ManualReviewForm onSuccess={onSuccess} onCancel={onCancel} editMode={editMode} initialData={initialData} />;
	}

	// For edit mode, route based on source
	if (isFormSource) {
		return <FormSourceReviewForm onSuccess={onSuccess} onCancel={onCancel} editMode={editMode} initialData={initialData} />;
	}

	return <ManualReviewForm onSuccess={onSuccess} onCancel={onCancel} editMode={editMode} initialData={initialData} />;
}
